import { Color, Link, LinkProps, withCitrusTheme } from '@gousto-internal/citrus-react';
import { CSSObject } from '@emotion/react';
import React from 'react';

type InlineLinkProps = LinkProps & {
  backgroundStyle?: 'light' | 'dark';
};

const linkPalettes = {
  light: {
    base: Color.Secondary_400,
    hover: Color.Secondary_700,
    focused: Color.Secondary_800,
    visited: Color.Secondary_900,
    disabled: Color.NeutralGrey_200,
  },
  dark: {
    base: Color.White,
    hover: Color.Secondary_50,
    focused: Color.Secondary_100,
    visited: Color.Secondary_200,
    disabled: Color.White,
  },
};

export const InlineLink = withCitrusTheme<InlineLinkProps>(
  (props: InlineLinkProps) => {
    const { backgroundStyle: _backgroundStyle, ...linkProps } = props;
    return <Link {...linkProps} />;
  },
  (theme, props: InlineLinkProps) => {
    const backgroundStyle = props.backgroundStyle || 'light';
    const palette = linkPalettes[backgroundStyle] || linkPalettes.light;

    return {
      '&&': {
        '& *[class*="Link1"], & span, & a, & button, & *': {
          color: `${theme.color(palette.base)} !important`,
          boxShadow: `0 1px 0 0 ${theme.color(palette.base)} !important`,
        },
      },

      '&&:hover': {
        '& *[class*="Link1"], & span, & a, & button, & *': {
          color: `${theme.color(palette.hover)} !important`,
          boxShadow: `0 1px 0 0 ${theme.color(palette.hover)} !important`,
        },
      },

      '&&:active': {
        '& *[class*="Link1"], & span, & a, & button, & *': {
          color: `${theme.color(palette.focused)} !important`,
        },
      },

      '&&:focus': {
        '& *[class*="Link1"], & span, & a, & button, & *': {
          color: `${theme.color(palette.focused)} !important`,
          boxShadow: `0 0 0 3px ${theme.color(palette.focused)} !important`,
        },
      },

      '&:visited, &:visited *, & a:visited, & a:visited *': {
        color: `${theme.color(palette.visited)} !important`,
        boxShadow: `0 0 0 3px ${theme.color(palette.visited)} !important`,
      },

      '&&[aria-disabled="true"]': {
        opacity: props.backgroundStyle === 'dark' ? '0.48 !important' : '1 !important',

        '& *[class*="Link1"], & span, & a, & button, & *': {
          color: `${theme.color(palette.disabled)} !important`,
          boxShadow: `0 1px 0 0 ${theme.color(palette.disabled)} !important`,
        },
      },
    } as CSSObject;
  },
);
